// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MGwN","comment":"styles_comment__1U4WZ"};